/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import providerSubscriptionFieldsetTemplate from './provider-subscription-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ProviderSubscriptionDirective($compile, $templateCache) {
    var linker = function (scope, element) {
        var template = $templateCache.get(providerSubscriptionFieldsetTemplate);
        element.html(template);
        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            providerSubscription: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/provider/subscription/provider-subscription.directive.js